export default "__VITE_ASSET__ayCbOiOn__"